import React from 'react';
import { Clock } from 'lucide-react';
import { formatDurationMinutes } from './formatVisitDuration';

function chip(label, value, open) {
  return (
    <span
      key={label}
      className={`inline-flex items-center gap-1 rounded-md border px-1.5 py-0.5 text-[10px] font-medium ${
        open
          ? 'border-amber-200 bg-amber-50 text-amber-900'
          : 'border-[#D5DEE8] bg-[#F7FAFC] text-[#3D5163]'
      }`}
    >
      <Clock className="h-2.5 w-2.5 opacity-70" />
      <span className="opacity-80">{label}</span>
      <span className="tabular-nums font-semibold text-[#071B34]">
        {value}{open ? ' …' : ''}
      </span>
    </span>
  );
}

/** Wait / consult / total time for one visit — shows live elapsed while open. */
export default function VisitTimingChips({ visit }) {
  const wait = formatDurationMinutes(visit?.wait_to_triage_minutes);
  const consult = formatDurationMinutes(visit?.triage_to_complete_minutes);
  const total = formatDurationMinutes(visit?.total_hospital_minutes);
  if (!wait && !consult && !total) {
    return (
      <div className="mt-2 text-[10px] text-[#9AADBE]" data-testid="visit-timing-empty">
        Time in hospital will appear after check-in / appointment time.
      </div>
    );
  }

  return (
    <div className="mt-2 flex flex-wrap gap-1.5" data-testid="visit-timing">
      {wait ? chip('Appt → triage', wait, !!visit.wait_to_triage_open) : null}
      {consult ? chip('Triage → done', consult, !!visit.triage_to_complete_open) : null}
      {total ? chip('Total in hospital', total, !!visit.total_hospital_open) : null}
    </div>
  );
}
